import React, { useState } from 'react';
import axios from 'axios';
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import {
  Row,
  Col,
  Card,
  CardBody,
  Container,
} from 'reactstrap';
import GetRequestComponent from '../../../components/Common/GetRequest';
import PutRequestComponent from '../../../components/Common/PutRequest';
const ExtendValidity = () => {
    const [url, setUrl] = useState('');
    const [requestBody, setRequestBody] = useState('');
    const [response, setResponse] = useState(null);
    const [breadcrumbItems] = useState([
      { title: 'Membership', link: '#' },
      { title: 'Extend Validity', link: '#' }
    ]);
    const headers=[
      {
        title:'apikey',
        type:'text',
        required:true,
      }
    ]
    const urlparams=[
      {
        title:'membership_id',
        type:'text',
        required:true,
      }
    ]
    const body=[
      {
        title:'validity_name',
        type:'text',
        required:true
      },
      {
        title:'validity_code',
        type:'text',
        required:true
      },
      {
        title:'payment_method',
        type:'dropdown',
        options:[{label:'Cash',value:'Cash'},{label:'Google Pay',value:'Google Pay'},{label:'Phone Pe',value:'Phone Pe'},{label:'UPI',value:'UPI'}],
        required:true
      },
      {
        title:'payment_note',
        type:'text'
      },
    ]
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
        <Breadcrumbs
            title="Extend Membership Validity"
            breadcrumbItems={breadcrumbItems}
          />
          <p>To Extend the Validity of Purchased Membership Plan. Fields marked with <span style={{color:"red"}}>*</span> are required</p>
      <PutRequestComponent title="Extend Membership Validity" headers={headers} urlparams={urlparams} body={body} url='/v2/tp/membership/:membership_id/extend_validity' type="form"/>
      </Container>
      </div>
    </React.Fragment>
  )
}

export default ExtendValidity;